<template>
    <div>
        <!-- Tabs -->
        <el-tabs v-model="activeName" type="border-card" v-loading="loading">
          <!-- 复查列表 strat -->
          <el-tab-pane label="复查列表" name="first">
            <div class="block">
                <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
            </div>

            <el-table :data="visionCheckData" border stripe class="mt15">
                <el-table-column prop="CheckName" label="检查人员姓名" min-width="10%"></el-table-column>
                <el-table-column prop="InputName" label="录入人员姓名" min-width="10%"></el-table-column>
                <el-table-column prop="InputTime" label="录入时间" min-width="10%"></el-table-column>
                <el-table-column prop="Diopterstatei" label="屈光状态" min-width="10%"></el-table-column>
                <el-table-column prop="RightEyeDegree" label="球镜OD(右眼)" min-width="10%"></el-table-column>
                <el-table-column prop="LeftEyeDegree" label="球镜OS(左眼)" min-width="10%"></el-table-column>
                <el-table-column prop="RightcolumnMirror" label="柱镜OD(右眼)" min-width="10%"></el-table-column>
                <el-table-column prop="LeftcolumnMirror" label="柱镜OS(左眼)" min-width="10%"></el-table-column>
                <el-table-column prop="Rightaxial" label="轴向OD(右眼)" min-width="10%"></el-table-column>
                <el-table-column prop="Leftaxial" label="轴向OS(左眼)" min-width="10%"></el-table-column>
                <el-table-column prop="NakedRightEyeDegree" label="裸眼视力OD(右眼)" min-width="10%"></el-table-column>
                <el-table-column prop="NakedLeftEyeDegree" label="裸眼视力OS(左眼)" min-width="10%"></el-table-column>
                <el-table-column prop="NakedBinoculusDegree" label="裸眼视力OU(双眼)" min-width="10%"></el-table-column>
                <el-table-column prop="CorrectRightEyeDegree" label="最佳矫正视力OD(右眼)" min-width="10%"></el-table-column>
                <el-table-column prop="CorrectLeftEyeDegree" label="最佳矫正视力OS(左眼)" min-width="10%"></el-table-column>
                <el-table-column prop="CorrectBinoculusDegree" label="最佳矫正视力OU(双眼)" min-width="10%"></el-table-column>
                <el-table-column prop="Interpupillary" label="瞳距" min-width="10%"></el-table-column>
                <el-table-column prop="Adminname" label="管理员姓名" min-width="10%"></el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" min-width="10%"></el-table-column>
                <el-table-column prop="operation" label="操作" min-width="10%">
                  <template v-slot="scope">
                    <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickm(scope.row)">修改</el-button>
                  </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pages">
              <el-pagination
                @current-change="handleCurrentPageChange"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="dataListnum"
                :current-page.sync="selectedPageNo">
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 复查列表 end -->

          <!-- 添加视力复查 start -->
          <el-tab-pane label="添加视力复查" name="second">
            <el-form :model="addCustomer" ref="addCustomerRef" label-width="68px">
              <el-form-item label="检查人员" class="addAdminForm">
                <el-input v-model="addCustomer.checkname" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="录入人员" class="addAdminForm">
                <el-input v-model="addCustomer.inputname" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="录入时间" class="addAdminForm">
                <el-date-picker v-model="addCustomer.inputtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>

              <div class="optometry">
                <el-form-item label="屈光状态" class="select2">
                  <el-select v-model="addCustomer.diopterstate" placeholder="请选择" style="width: 100%">
                    <el-option label="请选择" value="0"></el-option>
                    <el-option label="正视" value="6"></el-option>
                    <el-option label="远视" value="2"></el-option>
                    <el-option label="近视" value="1"></el-option>
                    <el-option label="散光" value="7"></el-option>
                    <el-option label="老花" value="3"></el-option>
                    <el-option label="屈光参差" value="8"></el-option>
                    <el-option label="远视性弱视" value="9"></el-option>
                    <el-option label="散光性弱视" value="10"></el-option>
                    <el-option label="近视性弱视" value="11"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!-- 视光信息 end -->

              <!-- 屈光度 -->
              <el-table :data="diopterData" border stripe class="mt20">
                <el-table-column label="屈光度" align="center">
                  <el-table-column label="OD(右眼)" align="center">
                    <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.righteyedegree" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.rightcolumnmirror" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.rightaxial" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="OS(左眼)" align="center">
                    <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.lefteyedegree" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.leftcolumnmirror" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.leftaxial" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 裸眼和矫正视力 -->
              <el-table :data="nakedEye" border stripe class="mt20">
                <el-table-column label="5m裸眼视力(5分记录法)" align="center">
                  <el-table-column prop="odRight" label="OD(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.nakedrighteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="osLeft" label="OS(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.nakedlefteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ouDouble" label="OU(双眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.nakedbinoculusdegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>

                <el-table-column label="最佳矫正视力(5分记录法)" align="center">
                  <el-table-column prop="odRight1" label="OD(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.correctrighteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="osLeft1" label="OS(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.correctlefteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ouDouble1" label="OU(双眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.correctbinoculusdegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 瞳距和ADD -->
              <el-table :data="addData" border stripe class="mt20">
                <el-table-column label="瞳距和ADD" align="center">
                  <el-table-column  prop="tongju" label="瞳距(单位:mm)">
                    <template slot-scope="scope">
                      <el-input v-model="addCustomer.interpupillary"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.addtype" placeholder="请选择" style="width: 100%">
                        <el-option label="0.00D" value="0"></el-option>
                        <el-option label="0.50D" value="1"></el-option>
                        <el-option label="0.75D" value="2"></el-option>
                        <el-option label="1.00D" value="3"></el-option>
                        <el-option label="1.25D" value="4"></el-option>
                        <el-option label="1.50D" value="5"></el-option>
                        <el-option label="1.75D" value="6"></el-option>
                        <el-option label="2.00D" value="7"></el-option>
                        <el-option label="2.25D" value="8"></el-option>
                        <el-option label="2.50D" value="9"></el-option>
                        <el-option label="2.75D" value="10"></el-option>
                        <el-option label="3.00D" value="11"></el-option>
                        <el-option label="3.25D" value="12"></el-option>
                        <el-option label="3.50D" value="13"></el-option>
                        <el-option label="3.75D" value="14"></el-option>
                        <el-option label="4.00D" value="15"></el-option>
                        <el-option label="4.25D" value="16"></el-option>
                        <el-option label="4.50D" value="17"></el-option>
                        <el-option label="4.75D" value="18"></el-option>
                        <el-option label="5.00D" value="19"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 眼轴，调节幅度 -->
              <el-table :data="tongJuData" border stripe class="mt20">
                <el-table-column  prop="tongju" label="右眼轴AL">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.alod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column  prop="tongju" label="左眼轴AL">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.alos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="右眼调节幅度(范围:0.00D~+22.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.ampod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="左眼调节幅度(范围:0.00D~+22.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.ampos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="双眼调节幅度(范围:0.00D~+22.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.ampou"></el-input>
                  </template>
                </el-table-column>
              </el-table>

              <!-- NRA，PRA -->
              <el-table :data="tongJuData" border stripe class="mt20">
                <el-table-column  prop="tongju" label="右眼NRA">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.nraod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column  prop="tongju" label="左眼NRA">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.nraos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="双眼NRA">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.nraou"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="右眼PRA">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.praod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="左眼PRA">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.praos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="双眼PRA">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.praou"></el-input>
                  </template>
                </el-table-column>
              </el-table>

              <!-- BCC，调节灵敏度 -->
              <el-table :data="tongJuData" border stripe class="mt20">
                <el-table-column  prop="tongju" label="BCC">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.bcc"></el-input>
                  </template>
                </el-table-column>
                <el-table-column  prop="tongju" label="右眼调节灵敏度">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.flipperod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="左眼调节灵敏度">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.flipperos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="双眼调节灵敏度">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.flipperou"></el-input>
                  </template>
                </el-table-column>
              </el-table>

              <el-form-item class="mt20">
                <el-button type="primary" @click="clickAdd">保存</el-button>
                <el-button type="info" @click="clickreturn1">返回</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 添加视力复查 end -->

          <!-- 修改视力复查 start -->
          <el-tab-pane label="修改视力复查" name="three" disabled="disabled">
            <el-form :model="editfucha" ref="editfuchaRef" label-width="68px">
              <el-form-item label="检查人员" class="addAdminForm">
                <el-input v-model="editfucha.checkname" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="录入人员" class="addAdminForm">
                <el-input v-model="editfucha.inputname" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="录入时间" class="addAdminForm">
                <el-date-picker v-model="editfucha.inputtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>

              <div class="optometry">
                <el-form-item label="屈光状态" class="select2">
                  <el-select v-model="editfucha.diopterstate" placeholder="请选择" style="width: 100%">
                    <el-option label="请选择" value="0"></el-option>
                    <el-option label="正视" value="6"></el-option>
                    <el-option label="远视" value="2"></el-option>
                    <el-option label="近视" value="1"></el-option>
                    <el-option label="散光" value="7"></el-option>
                    <el-option label="老花" value="3"></el-option>
                    <el-option label="屈光参差" value="8"></el-option>
                    <el-option label="远视性弱视" value="9"></el-option>
                    <el-option label="散光性弱视" value="10"></el-option>
                    <el-option label="近视性弱视" value="11"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!-- 视光信息 end -->

              <!-- 屈光度 -->
              <el-table :data="diopterData" border stripe class="mt20">
                <el-table-column label="屈光度" align="center">
                  <el-table-column label="OD(右眼)" align="center">
                    <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.righteyedegree" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.rightcolumnmirror" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.rightaxial" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="OS(左眼)" align="center">
                    <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.lefteyedegree" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.leftcolumnmirror" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.leftaxial" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 裸眼和矫正视力 -->
              <el-table :data="nakedEye" border stripe class="mt20">
                <el-table-column label="5m裸眼视力(5分记录法)" align="center">
                  <el-table-column prop="odRight" label="OD(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.nakedrighteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="osLeft" label="OS(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.nakedlefteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ouDouble" label="OU(双眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.nakedbinoculusdegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>

                <el-table-column label="最佳矫正视力(5分记录法)" align="center">
                  <el-table-column prop="odRight1" label="OD(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.correctrighteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="osLeft1" label="OS(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.correctlefteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ouDouble1" label="OU(双眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.correctbinoculusdegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 瞳距和ADD -->
              <el-table :data="addData" border stripe class="mt20">
                <el-table-column label="瞳距和ADD" align="center">
                  <el-table-column  prop="tongju" label="瞳距(单位:mm)">
                    <template slot-scope="scope">
                      <el-input v-model="editfucha.interpupillary"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.addtype" placeholder="请选择" style="width: 100%">
                        <el-option label="0.00D" value="0"></el-option>
                        <el-option label="0.50D" value="1"></el-option>
                        <el-option label="0.75D" value="2"></el-option>
                        <el-option label="1.00D" value="3"></el-option>
                        <el-option label="1.25D" value="4"></el-option>
                        <el-option label="1.50D" value="5"></el-option>
                        <el-option label="1.75D" value="6"></el-option>
                        <el-option label="2.00D" value="7"></el-option>
                        <el-option label="2.25D" value="8"></el-option>
                        <el-option label="2.50D" value="9"></el-option>
                        <el-option label="2.75D" value="10"></el-option>
                        <el-option label="3.00D" value="11"></el-option>
                        <el-option label="3.25D" value="12"></el-option>
                        <el-option label="3.50D" value="13"></el-option>
                        <el-option label="3.75D" value="14"></el-option>
                        <el-option label="4.00D" value="15"></el-option>
                        <el-option label="4.25D" value="16"></el-option>
                        <el-option label="4.50D" value="17"></el-option>
                        <el-option label="4.75D" value="18"></el-option>
                        <el-option label="5.00D" value="19"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 眼轴，调节幅度 -->
              <el-table :data="tongJuData" border stripe class="mt20">
                <el-table-column  prop="tongju" label="右眼轴AL">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.alod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column  prop="tongju" label="左眼轴AL">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.alos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="右眼调节幅度(范围:0.00D~+22.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.ampod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="左眼调节幅度(范围:0.00D~+22.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.ampos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="双眼调节幅度(范围:0.00D~+22.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.ampou"></el-input>
                  </template>
                </el-table-column>
              </el-table>

              <!-- NRA，PRA -->
              <el-table :data="tongJuData" border stripe class="mt20">
                <el-table-column  prop="tongju" label="右眼NRA">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.nraod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column  prop="tongju" label="左眼NRA">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.nraos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="双眼NRA">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.nraou"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="右眼PRA">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.praod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="左眼PRA">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.praos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="双眼PRA">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.praou"></el-input>
                  </template>
                </el-table-column>
              </el-table>

              <!-- BCC，调节灵敏度 -->
              <el-table :data="tongJuData" border stripe class="mt20">
                <el-table-column  prop="tongju" label="BCC">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.bcc"></el-input>
                  </template>
                </el-table-column>
                <el-table-column  prop="tongju" label="右眼调节灵敏度">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.flipperod"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="左眼调节灵敏度">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.flipperos"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="adjust" label="双眼调节灵敏度">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.flipperou"></el-input>
                  </template>
                </el-table-column>
              </el-table>

              <el-form-item class="mt20">
                <el-button type="primary" @click="clickModify">保存</el-button>
                <el-button type="info" @click="clickreturn2">返回</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 修改视力复查 end -->

        </el-tabs>
        <!-- Tabs end -->
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      activeName: 'first',
      loading: false,
      selectedPageNo: 1,
      dataListnum: 0,
      value1: '',
      value2: '',
      visionCheckData: [],
      addCustomer: {
        glassuserid: '',
        checkname: '',
        inputname: '',
        inputtime: '',
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: '',
        addtype: '0',
        alod: '0.00',
        alos: '0.00',
        ampod: '0.00',
        ampos: '0.00',
        ampou: '0.00',
        nraod: '0.00',
        nraos: '0.00',
        nraou: '0.00',
        praod: '0.00',
        praos: '0.00',
        praou: '0.00',
        bcc: '0.00',
        flipperod: '0.00',
        flipperos: '0.00',
        flipperou: '0.00'
      },
      editfucha: {
        fuchaid: '',
        checkname: '',
        inputname: '',
        inputtime: '',
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: '',
        addtype: '0',
        alod: '0.00',
        alos: '0.00',
        ampod: '0.00',
        ampos: '0.00',
        ampou: '0.00',
        nraod: '0.00',
        nraos: '0.00',
        nraou: '0.00',
        praod: '0.00',
        praos: '0.00',
        praou: '0.00',
        bcc: '0.00',
        flipperod: '0.00',
        flipperos: '0.00',
        flipperou: '0.00'
      },
      diopterData: [
        {
          rightEye1: '右眼',
          rightEye2: '右眼',
          rightEye3: '右眼',
          leftEye1: '右眼',
          leftEye2: '右眼',
          leftEye3: '右眼'
        }
      ],
      // ADD和调节幅度
      addData: [
        {
          add: 'add',
          adjust: '调节幅度'
        }
      ],
      // 裸眼和矫正视力
      nakedEye: [
        { odRight: '请选择', osLeft: '请选择', ouDouble: '请选择', odRight1: '请选择', osLeft1: '请选择', ouDouble1: '请选择' }
      ],
      tongJuData: [
        { tongju: '请输入', leftEye: '请选择', rightEye: '请选择' }
      ],
      eyedegreelist: [
        { value: '0', label: '请选择' },
        { value: '3.5', label: '3.5' },
        { value: '3.6', label: '3.6' },
        { value: '3.7', label: '3.7' },
        { value: '3.8', label: '3.8' },
        { value: '3.9', label: '3.9' },
        { value: '4.0', label: '4.0' },
        { value: '4.1', label: '4.1' },
        { value: '4.2', label: '4.2' },
        { value: '4.3', label: '4.3' },
        { value: '4.4', label: '4.4' },
        { value: '4.5', label: '4.5' },
        { value: '4.6', label: '4.6' },
        { value: '4.7', label: '4.7' },
        { value: '4.8', label: '4.8' },
        { value: '4.9', label: '4.9' },
        { value: '5.0', label: '5.0' },
        { value: '5.1', label: '5.1' },
        { value: '5.2', label: '5.2' },
        { value: '5.3', label: '5.3' }
      ]
    }
  },
  mounted () {
    var that = this
    this.addCustomer.inputtime = Vue.prototype.FunGetTimeStringLong()
  },
  methods: {
    LoadData (row) {
      this.addCustomer.glassuserid = row.Id
      this.apiGetMiniProgramDouMaiKeJiUserFuChaNum()
      this.apiGetMiniProgramDouMaiKeJiUserFuChaList()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetMiniProgramDouMaiKeJiUserFuChaList()
    },
    clickreturn1 () {
      this.activeName = 'first'
    },
    clickreturn2 () {
      this.activeName = 'first'
    },
    clickAdd () {
      this.apiAddMiniProgramDouMaiKeJiUserFuCha()
    },
    clickm (row) {
      this.editfucha.fuchaid = row.Id
      this.editfucha.checkname = row.CheckName
      this.editfucha.inputname = row.InputName
      this.editfucha.inputtime = row.InputTime
      this.editfucha.diopterstate = row.DiopterState.toString()
      this.editfucha.righteyedegree = row.RightEyeDegree
      this.editfucha.rightcolumnmirror = row.RightcolumnMirror
      this.editfucha.rightaxial = row.Rightaxial
      this.editfucha.lefteyedegree = row.LeftEyeDegree
      this.editfucha.leftcolumnmirror = row.LeftcolumnMirror
      this.editfucha.leftaxial = row.Leftaxial
      this.editfucha.nakedrighteyedegree = row.NakedRightEyeDegree.toString()
      this.editfucha.nakedlefteyedegree = row.NakedLeftEyeDegree.toString()
      this.editfucha.nakedbinoculusdegree = row.NakedBinoculusDegree.toString()
      this.editfucha.correctrighteyedegree = row.CorrectRightEyeDegree.toString()
      this.editfucha.correctlefteyedegree = row.CorrectLeftEyeDegree.toString()
      this.editfucha.correctbinoculusdegree = row.CorrectBinoculusDegree.toString()
      this.editfucha.interpupillary = row.Interpupillary
      this.editfucha.addtype = row.Addtype.toString()
      this.editfucha.alod = row.Alod
      this.editfucha.alos = row.Alos
      this.editfucha.ampod = row.Ampod
      this.editfucha.ampos = row.Ampos
      this.editfucha.ampou = row.Ampou
      this.editfucha.nraod = row.Nraod
      this.editfucha.nraos = row.Nraos
      this.editfucha.nraou = row.Nraou
      this.editfucha.praod = row.Praod
      this.editfucha.praos = row.Praos
      this.editfucha.praou = row.Praou
      this.editfucha.bcc = row.Bcc
      this.editfucha.flipperod = row.Flipperod
      this.editfucha.flipperos = row.Flipperos
      this.editfucha.flipperou = row.Flipperou

      this.activeName = 'three'
    },
    clickModify () {
      this.apiEditMiniProgramDouMaiKeJiUserFuCha()
    },
    apiGetMiniProgramDouMaiKeJiUserFuChaList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.addCustomer.glassuserid,
        pageno: that.selectedPageNo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniProgramDouMaiKeJiUserFuChaList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.visionCheckData = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetMiniProgramDouMaiKeJiUserFuChaNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.addCustomer.glassuserid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniProgramDouMaiKeJiUserFuChaNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddMiniProgramDouMaiKeJiUserFuCha: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.addCustomer.glassuserid,
        checkname: that.addCustomer.checkname,
        inputname: that.addCustomer.inputname,
        inputtime: that.addCustomer.inputtime,
        diopterstate: that.addCustomer.diopterstate,
        righteyedegree: that.addCustomer.righteyedegree,
        rightcolumnmirror: that.addCustomer.rightcolumnmirror,
        rightaxial: that.addCustomer.rightaxial,
        lefteyedegree: that.addCustomer.lefteyedegree,
        leftcolumnmirror: that.addCustomer.leftcolumnmirror,
        leftaxial: that.addCustomer.leftaxial,
        nakedrighteyedegree: that.addCustomer.nakedrighteyedegree,
        nakedlefteyedegree: that.addCustomer.nakedlefteyedegree,
        nakedbinoculusdegree: that.addCustomer.nakedbinoculusdegree,
        correctrighteyedegree: that.addCustomer.correctrighteyedegree,
        correctlefteyedegree: that.addCustomer.correctlefteyedegree,
        correctbinoculusdegree: that.addCustomer.correctbinoculusdegree,
        interpupillary: that.addCustomer.interpupillary,
        addtype: that.addCustomer.addtype,
        alod: that.addCustomer.alod,
        alos: that.addCustomer.alos,
        ampod: that.addCustomer.ampod,
        ampos: that.addCustomer.ampos,
        ampou: that.addCustomer.ampou,
        nraod: that.addCustomer.nraod,
        nraos: that.addCustomer.nraos,
        nraou: that.addCustomer.nraou,
        praod: that.addCustomer.praod,
        praos: that.addCustomer.praos,
        praou: that.addCustomer.praou,
        bcc: that.addCustomer.bcc,
        flipperod: that.addCustomer.flipperod,
        flipperos: that.addCustomer.flipperos,
        flipperou: that.addCustomer.flipperou
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMiniProgramDouMaiKeJiUserFuCha, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.addCustomer.checkname = ''
            that.addCustomer.inputname = ''
            that.addCustomer.diopterstate = '0'
            that.addCustomer.righteyedegree = '0.00'
            that.addCustomer.rightcolumnmirror = '0.00'
            that.addCustomer.rightaxial = '0'
            that.addCustomer.lefteyedegree = '0.00'
            that.addCustomer.leftcolumnmirror = '0.00'
            that.addCustomer.leftaxial = '0'
            that.addCustomer.nakedrighteyedegree = '0'
            that.addCustomer.nakedlefteyedegree = '0'
            that.addCustomer.nakedbinoculusdegree = '0'
            that.addCustomer.correctrighteyedegree = '0'
            that.addCustomer.correctlefteyedegree = '0'
            that.addCustomer.correctbinoculusdegree = '0'
            that.addCustomer.interpupillary = ''
            that.addCustomer.addtype = '0'
            that.addCustomer.alod = '0.00'
            that.addCustomer.alos = '0.00'
            that.addCustomer.ampod = '0.00'
            that.addCustomer.ampos = '0.00'
            that.addCustomer.ampou = '0.00'
            that.addCustomer.nraod = '0.00'
            that.addCustomer.nraos = '0.00'
            that.addCustomer.nraou = '0.00'
            that.addCustomer.praod = '0.00'
            that.addCustomer.praos = '0.00'
            that.addCustomer.praou = '0.00'
            that.addCustomer.bcc = '0.00'
            that.addCustomer.flipperod = '0.00'
            that.addCustomer.flipperos = '0.00'
            that.addCustomer.flipperou = '0.00'

            that.activeName = 'first'
            that.apiGetMiniProgramDouMaiKeJiUserFuChaNum()
            that.apiGetMiniProgramDouMaiKeJiUserFuChaList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditMiniProgramDouMaiKeJiUserFuCha: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fuchaid: that.editfucha.fuchaid,
        checkname: that.editfucha.checkname,
        inputname: that.editfucha.inputname,
        inputtime: that.editfucha.inputtime,
        diopterstate: that.editfucha.diopterstate,
        righteyedegree: that.editfucha.righteyedegree,
        rightcolumnmirror: that.editfucha.rightcolumnmirror,
        rightaxial: that.editfucha.rightaxial,
        lefteyedegree: that.editfucha.lefteyedegree,
        leftcolumnmirror: that.editfucha.leftcolumnmirror,
        leftaxial: that.editfucha.leftaxial,
        nakedrighteyedegree: that.editfucha.nakedrighteyedegree,
        nakedlefteyedegree: that.editfucha.nakedlefteyedegree,
        nakedbinoculusdegree: that.editfucha.nakedbinoculusdegree,
        correctrighteyedegree: that.editfucha.correctrighteyedegree,
        correctlefteyedegree: that.editfucha.correctlefteyedegree,
        correctbinoculusdegree: that.editfucha.correctbinoculusdegree,
        interpupillary: that.editfucha.interpupillary,
        addtype: that.editfucha.addtype,
        alod: that.editfucha.alod,
        alos: that.editfucha.alos,
        ampod: that.editfucha.ampod,
        ampos: that.editfucha.ampos,
        ampou: that.editfucha.ampou,
        nraod: that.editfucha.nraod,
        nraos: that.editfucha.nraos,
        nraou: that.editfucha.nraou,
        praod: that.editfucha.praod,
        praos: that.editfucha.praos,
        praou: that.editfucha.praou,
        bcc: that.editfucha.bcc,
        flipperod: that.editfucha.flipperod,
        flipperos: that.editfucha.flipperos,
        flipperou: that.editfucha.flipperou
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditMiniProgramDouMaiKeJiUserFuCha, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetMiniProgramDouMaiKeJiUserFuChaList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
